import styled from 'styled-components';

import {
  fontFamilySecondary,
  colorBlueGray,
  mediaQueryMobileMin,
  fontFamilyPrimary,
} from 'styles';

export const WrapperModal = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: fixed;
  bottom: ${({ isOpen }) => (isOpen ? '65px' : '-800px')};
  color: #fff;
  font-size: 14px;
  width: 100%;
  height: auto;
  background-color: #1e2621;
  padding: 12px 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  align-items: center;
  transition: bottom 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  border-radius: 4px;

  @media all and ${mediaQueryMobileMin} {
    bottom: ${({ isOpen }) => (isOpen ? '24px' : '-800px')};
    max-width: 600px;
    height: 48px;
  }
`;

export const ModalDescription = styled.div`
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  display: inline-block;
`;

export const ModalCloseBtn = styled.button`
  font-family: ${fontFamilySecondary};
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  background-color: transparent;
  color: #55b391;

  &:hover {
    opacity: 0.8;
    background-color: #000;
    border-color: ${colorBlueGray};
  }
`;
